<template>
  <section class="tight">
    <div class="wrap">
      <div class="stats">
        <div class="stat">
          <div class="n">{{ labelsState['lv_stat_setup_value'] || '3 min' }}</div>
          <div class="l">{{ labelsState['lv_stat_setup_label'] || 'Average setup' }}</div>
        </div>
        <div class="stat">
          <div class="n">{{ labelsState['lv_stat_resolved_value'] || '98%' }}</div>
          <div class="l">{{ labelsState['lv_stat_resolved_label'] || 'Queries resolved' }}</div>
        </div>
        <div class="stat">
          <div class="n">{{ labelsState['lv_stat_conversion_value'] || '4.7×' }}</div>
          <div class="l">{{ labelsState['lv_stat_conversion_label'] || 'Conversion vs. form' }}</div>
        </div>
        <div class="stat">
          <div class="n">{{ labelsState['lv_stat_uptime_value'] || '24/7' }}</div>
          <div class="l">{{ labelsState['lv_stat_uptime_label'] || 'Non-stop support' }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'StatsV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
};
</script>
